<ng-template elderToolbarColumn="right.actions">
  <app-view-mode-context-menu></app-view-mode-context-menu>
  <app-facility-context-menu></app-facility-context-menu>
</ng-template>

<ng-template elderToolbarColumn="center">
  @if (activeContext$ | async; as context) {
    @switch (context?.viewMode) {
      @case (ViewMode.PREVIEW) {
        <app-interval-context-menu></app-interval-context-menu>
      }
      @case (ViewMode.LIVE) {
        <span>{{ context?.liveTimestamp?.toString() | date: 'medium' }}</span>
      }
    }
  }
</ng-template>

<div class="layout-col full">
  @if (activeContext$ | async; as context) {
    <mat-tab-group class="flex" elderTabGroupRouting="utilisationOverview" [animationDuration]="0">
      <mat-tab label="{{ 'utilization.title' | translate }}" elderTab="utilisation">
        <app-facility-utilisation-detail
          class="flex"
          *matTabContent
          [mexusContext]="context"
        ></app-facility-utilisation-detail>
      </mat-tab>

      <mat-tab label="{{ 'orders.work.title' | translate }}">
        <elder-basic-pane-layout class="full" *matTabContent>
          <elder-pane>
            <app-work-order-browser class="flex" [mexusContext]="context"></app-work-order-browser>
          </elder-pane>
        </elder-basic-pane-layout>
      </mat-tab>

      <mat-tab label="{{ 'shopfloor.workcenters.workcenter' | translate }}" elderTab="workCenters">
        <elder-basic-pane-layout class="full" *matTabContent>
          <elder-pane>
            <app-utilization-report-table class="flex" [mexusContext]="context">
            </app-utilization-report-table>
          </elder-pane>
        </elder-basic-pane-layout>
      </mat-tab>
    </mat-tab-group>
  }
</div>
